import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { style } from '../layer.css';

export const toolbar = style({
  display: 'flex',
  backgroundColor: themeVars.container.primary.background.idle,
  padding: space.s4,
  verticalAlign: 'middle',
  outline: `1px solid ${themeVars.container.border.default} `,
  outlineOffset: '-1px',

  boxShadow:
    '0px 0px 2px 0px rgba(81,97,108,.3),0px 4px 6px 0px rgba(81,97,108,.05),0px 10px 26px 0px rgba(81,97,108,.15)',
  borderRadius: borderRadius.r8,
});

export const toolbarToggleGroup = style({
  display: 'flex',
});
